import {identify} from 'logrocket'

import {EnvironmentType} from '@possible/cassandra'
import Log from 'src/lib/loggingUtil'
import {getEnvironment} from 'src/lib/utils/environmentUtil'

type IdentifyUser = (userId: string, params?: Parameters<typeof identify>[0]) => void

type LRRequest = {
  body?: string
  reqId: string
  headers: {[key: string]: string | undefined}
  url: string
  method: string
  referrer?: string
  mode?: string
  credentials?: string
}
type RequestSanitizer = (request: LRRequest) => LRRequest | null

type LRResponse = {
  reqId: string
  status?: number
  headers: {[key: string]: string | undefined}
  body?: string
  method: string
}
type ResponseSanitizer = (reponse: LRResponse) => LRResponse | null

const getLogRocketAppId = async (): Promise<string> =>
  (await getEnvironment()) === EnvironmentType.Prod
    ? 'dokrpq/possible-production'
    : 'dokrpq/possible-dev'

const sessionReplayLogger = (error: unknown, message: string): void => {
  Log.error(error, `[SessionReplay]: ${message}`)
}

const requestSanitizer: RequestSanitizer = (request) => {
  request.body = undefined

  /* `Authorization` headers are officially not case sensitive at the browser level however these
   * must be logged to LogRocket before they hit the "network layer" and LogRocket doesn't seem to
   * apply the same normalization. As a result, I've seen different capitalizations on different
   * platforms so we are redacting both cases.
   */
  if (request.headers.Authorization) {
    request.headers.Authorization = 'redacted'
  }

  if (request.headers.authorization) {
    request.headers.authorization = 'redacted'
  }

  return request
}

const responseSanitizer: ResponseSanitizer = (response) => {
  response.body = undefined

  /* `Authorization` headers are officially not case sensitive at the browser level however these
   * must be logged to LogRocket before they hit the "network layer" and LogRocket doesn't seem to
   * apply the same normalization. As a result, I've seen different capitalizations on different
   * platforms so we are redacting both cases.
   */
  if (response.headers.Authorization) {
    response.headers.Authorization = 'redacted'
  }

  if (response.headers.authorization) {
    response.headers.authorization = 'redacted'
  }

  return response
}

const redactionTag = 'private'

export {getLogRocketAppId, redactionTag, requestSanitizer, responseSanitizer, sessionReplayLogger}
export type {IdentifyUser}
